export default function ProjectsPage() {
  return (
    <div>
      <div></div>
    </div>
  );
}
